import { render } from "./ArchivoSinPlanilla.vue?vue&type=template&id=54880a20&scoped=true"
import script from "./ArchivoSinPlanilla.vue?vue&type=script&lang=js"
export * from "./ArchivoSinPlanilla.vue?vue&type=script&lang=js"

import "./ArchivoSinPlanilla.vue?vue&type=style&index=0&id=54880a20&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54880a20"]])

export default __exports__